import React from 'react'
import Slider from 'antd/lib/slider'

class Range extends React.Component {
  rangeProps() {
    return {
      defaultValue: [this.props.field.min, this.props.field.max],
      min: this.props.field.min,
      max: this.props.field.max,
      step: this.props.field.step || 1,
    }
  }

  renderLabel() {
    return this.props.field.label ? <div className="gw-search__field-label">{this.props.field.label}</div> : ''
  }

  getPreVal() {
    return this.props.field.preVal || ''
  }

  getPostVal() {
    return this.props.field.postVal || ''
  }

  renderMinVal() {
    const preVal = this.getPreVal()
    const postVal = this.getPostVal()
    return (
      <span className="range__min-val range__val-display">
        {preVal}
        {this.props.value[0]}
        <span dangerouslySetInnerHTML={{__html: postVal}} />
      </span>
    )
  }

  renderMaxVal() {
    const preVal = this.getPreVal()
    let postVal = this.getPostVal()
    // add + on to the end if we are at the max value but we're including searches above this max value
    if (this.props.field.rangeAboveMax && this.props.value[1] === this.props.field.max) postVal += '+'
    return (
      <span className="range__max-val range__val-display">
        {preVal}
        {this.props.value[1]}
        <span dangerouslySetInnerHTML={{__html: postVal}} />
      </span>
    )
  }

  render() {
    return (
      <div className="gw-search__field gw-search__field-range">
        {this.renderLabel()}
        <div className="range-wrap">
          <div className="range__slider">
            <Slider onChange={this.props.onChange} range {...this.rangeProps()} value={this.props.value}/>
          </div>
          {this.renderMinVal()}
          {this.renderMaxVal()}
        </div>
      </div>
    )
  }
}

export default Range



// WEBPACK FOOTER //
// ./src/components/search/fields/Range.js